import { Component, Vue } from 'vue-property-decorator'
import { ShiftSimpleVO, ShiftServiceProxy } from '@/service-proxies/app-v2/time.service-proxies'
import { Column } from 'ant-design-vue/types/table/column'
import { state, actions } from '../store'
import { Reactive } from '@/utils/decorators'
import { Modal } from 'ant-design-vue'

const ssp = new ShiftServiceProxy()

@Component
export default class ModelTable extends Vue {
  @Reactive(state) modelList = []
  @Reactive(state) currentModelId = ''
  loading = false

  get canUpdateOrDelete() {
    return !!this.currentModelId
  }

  get columns(): Partial<Column>[] {
    return [
      {
        title: this.$t('actions'),
        dataIndex: 'id',
        customRender: (id, record) => {
          return [
            <a disabled={!this.canUpdateOrDelete} onClick={() => this.handleEdit(id)}>
              {this.$t('edit')}
            </a>,
            this.canUpdateOrDelete ? <a-divider type="vertical" /> : null,
            <a class="del-color" disabled={!this.canUpdateOrDelete} onClick={this.handleDelete}>
              {this.$t('delete')}
            </a>,
            <a-divider type="vertical" />,
            <a style="color:red" onClick={() => this.handleArchive(record)}>{this.$t('page_place_on_file')}</a>,
          ]
        },
      },
      {
        title: this.$t('page_shift_model_code'),
        dataIndex: 'code',
        ellipsis: true,
        width: '25%',
      },
      {
        title: this.$t('page_shift_model_name'),
        dataIndex: 'name',
        ellipsis: true,
        width: '25%',
      },
    ]
  }

  get customRow() {
    return (record: ShiftSimpleVO) => ({
      on: {
        click: () => {
          actions.setCurrentModelId(record.id)
        },
      },
    })
  }

  handleEdit(id: string) {
    actions.setCurrentModelId(id)
    actions.setVisible({ updateForm: true })
  }

  async handleDelete() {
    Modal.confirm({
      title: this.$t('page_resource_pool_confirm_delete'),
      onOk: async () => {
        await ssp.deleteShift(this.currentModelId)
        await actions.loadModelList()
      },
    })
  }

  handleArchive(record) {
    Modal.confirm({
      title: this.$t('确定要归档吗?'),
      onOk: async () => {
        await ssp.updateShiftBasic({ colour: record.colour, id: record.id, name: record.name, status: 0 } as any)
        await actions.loadModelList()
      },
    })
  }

  render() {
    return (
      <a-table
        size="small"
        columns={this.columns}
        dataSource={this.modelList}
        customRow={this.customRow}
        pagination={false}
        loading={this.loading}
        bordered
        rowClassName={record => (record.id === this.currentModelId ? 'shift__current-row' : '')}
      />
    )
  }
}
